<template>
  <span>
    <b-modal
      title="Import Results"
      :id="modal_id"
      size="sm"
      modalClass="modal-primary"
      okVariant="success"
      :centered="true"
      okTitle="Import"
      @ok="submit"
    >
      <input
        ref="file"
        class="form-control"
        type="file"
        accept=".xltm, .xlsm, .xlsx"
        @change="setFile($event)"
      />
    </b-modal>

    <b-button
      v-if="importing"
      disabled
      variant="secondary"
      :size="size"
      class="px-1 py-0 mr-1"
    >
      <i class="fa fa-spinner fa-spin"></i> Importing
    </b-button>

    <b-button
      v-else
      variant="primary"
      class="px-1 py-0 mr-1"
      title="Import Results"
      :size="size"
      @click="showModal"
    >
      <i class="fa fa-upload"></i> Import
    </b-button>
  </span>
</template>

<script>
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const ResultImportRepository = LabRepositoryFactory.get("resultImport");

export default {
  name: "ResultExportImportButton",
  props: {
    result_export: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      file: null,
      importing: false,
    };
  },
  computed: {
    modal_id() {
      return "import-modal-" + this.result_export.id;
    },
  },
  methods: {
    showModal() {
      this.$bvModal.show(this.modal_id);
    },
    /**
     * Store file in component on input change
     */
    setFile() {
      this.file = this.$refs.file.files[0];
    },

    /**
     * Submit the import doc
     */
    async submit() {
      console.log(this.file);

      // set downloading flag
      this.importing = true;

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("result_export_id", this.result_export.id);

      //  request and download file
      await ResultImportRepository.create(formData).then((response) => {
        console.log(response);
      });

      // set downloading flag
      this.importing = false;
    },
  },
};
</script>